import { getLocaleUtil } from '../../main/utils/locale.util.ts';

function confirmPassword<T extends { newPassword: string; confirmPassword: string }>({
  newPassword,
  confirmPassword,
}: T): boolean {
  return newPassword === confirmPassword;
}

export function getConfirmPasswordRefiner(): [typeof confirmPassword, string] {
  return [confirmPassword, getLocaleUtil().select('accounts:field_confirm_password_mismatch_error')] as const;
}
